import * as entityTypes from "../../types/admin/entityTypes";

const initialState = {
  loading: false,
  info: null,
  error: null,
};

export const createReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.CREATE_ENTITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.CREATE_ENTITY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.CREATE_ENTITY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getAllEntityReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ALL_ENTITY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ALL_ENTITY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ALL_ENTITY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
}

export const getAllEntityWithoutPaginationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ALL_ENTITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ALL_ENTITY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ALL_ENTITY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getSingleEntityReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_SINGLE_ENTITY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_SINGLE_ENTITY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_SINGLE_ENTITY_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateEntityOverviewReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.UPDATE_ENTITY_OVERVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.UPDATE_ENTITY_OVERVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.UPDATE_ENTITY_OVERVIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateEntityFormatsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.UPDATE_ENTITY_FORMATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.UPDATE_ENTITY_FORMATS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.UPDATE_ENTITY_FORMATS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getEntityFormatsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ENTITY_FORMATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ENTITY_FORMATS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ENTITY_FORMATS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const createEntityFormatsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.CREATE_ENTITY_FORMATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.CREATE_ENTITY_FORMATS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.CREATE_ENTITY_FORMATS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const addEntityCommentsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.ADD_ENTITY_COMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.ADD_ENTITY_COMMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.ADD_ENTITY_COMMENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getEntityCommentsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ENTITY_COMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ENTITY_COMMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ENTITY_COMMENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getEntityActivityLogsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ENTITY_ACTIVITY_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ENTITY_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ENTITY_ACTIVITY_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};
